import { t } from 'i18next'

import type { TPropostaSchemaInput } from '@/features/proposta/schemas'
export class VagaValidator {
  private readonly vagaIds: TPropostaSchemaInput['informacoesIniciais']['vagaIds']
  private readonly possuiAcessoriosExtras: boolean
  private readonly simulacaoUnidade: TPropostaSchemaInput['informacoesIniciais']['simulacaoUnidade']

  constructor({
    simulacaoUnidade,
    vagaIds,
    possuiAcessoriosExtras,
  }: {
    simulacaoUnidade: TPropostaSchemaInput['informacoesIniciais']['simulacaoUnidade']
    possuiAcessoriosExtras: boolean
    vagaIds: TPropostaSchemaInput['informacoesIniciais']['vagaIds']
  }) {
    this.vagaIds = vagaIds
    this.simulacaoUnidade = simulacaoUnidade
    this.possuiAcessoriosExtras = possuiAcessoriosExtras
  }

  validate(): string | null {
    if (!this.simulacaoUnidade) return null
    if (!this.simulacaoUnidade.produto.acessorioObrigatorio && !this.possuiAcessoriosExtras) return null
    if (!this.vagaIds.length) return t('proposta:informacoes_iniciais.cards.vaga_padrao.required')
    return null
  }
}
